export interface ChecklistPortoComplementaryItem {
  key: ChecklistPortoComplementaryCategory;
  label: string;
  items: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    position: any;
    value: string;
    label: string;
  }[];
}

export enum ChecklistPortoComplementaryCategory {
  One = 'one',
  Two = 'two',
  Three = 'three',
  Four = 'four',
  Five = 'five',
  Six = 'six',
  Seven = 'seven',
  Eight = 'eight',
  Nine = 'nine',
  Ten = 'ten',
}

export const checklistPortoComplementaryItems: ChecklistPortoComplementaryItem[] =
  [
    {
      key: ChecklistPortoComplementaryCategory.One,
      label: '1 - PNEUS',
      items: [
        {
          position: ChecklistPortoComplementaryCategory.One,
          value: 'domain.enums.checklist_complementary_items.tire_front_right',
          label: 'Pneu Dianteiro Direito',
        },
        {
          position: ChecklistPortoComplementaryCategory.One,
          value: 'domain.enums.checklist_complementary_items.tire_front_left',
          label: 'Pneu Dianteiro Esquerdo',
        },
        {
          position: ChecklistPortoComplementaryCategory.One,
          value: 'domain.enums.checklist_complementary_items.tire_rear_right',
          label: 'Pneu Traseiro Direito',
        },
        {
          position: ChecklistPortoComplementaryCategory.One,
          value: 'domain.enums.checklist_complementary_items.tire_rear_left',
          label: 'Pneu Traseiro Esquerdo',
        },
        {
          position: ChecklistPortoComplementaryCategory.One,
          value: 'domain.enums.checklist_complementary_items.tire_spare',
          label: 'Pneu Estepe',
        },
        {
          position: ChecklistPortoComplementaryCategory.One,
          value: 'domain.enums.checklist_complementary_items.balancing',
          label: 'Balanceamento',
        },
      ],
    },
    {
      key: ChecklistPortoComplementaryCategory.Two,
      label: '2 - SUSPENSÃO/DIREÇÃO',
      items: [
        {
          position: ChecklistPortoComplementaryCategory.Two,
          value:
            'domain.enums.checklist_complementary_items.axial_articular_right',
          label: 'Articulador Axial Direito',
        },
        {
          position: ChecklistPortoComplementaryCategory.Two,
          value:
            'domain.enums.checklist_complementary_items.axial_articular_left',
          label: 'Articulador Axial Esquerdo',
        },
        {
          position: ChecklistPortoComplementaryCategory.Two,
          value: 'domain.enums.checklist_complementary_items.tie_rod_bushing',
          label: 'Bucha da Barra de Direção',
        },
        {
          position: ChecklistPortoComplementaryCategory.Two,
          value:
            'domain.enums.checklist_complementary_items.steering_box_bushing',
          label: 'Bucha da Caixa de Direção',
        },
        {
          position: ChecklistPortoComplementaryCategory.Two,
          value:
            'domain.enums.checklist_complementary_items.steering_box_mechanica',
          label: 'Caixa de Direção Mecânica',
        },
        {
          position: ChecklistPortoComplementaryCategory.Two,
          value:
            'domain.enums.checklist_complementary_items.steering_box_hydraulic',
          label: 'Caixa de Direção Hidráulica',
        },
        {
          position: ChecklistPortoComplementaryCategory.Two,
          value: 'domain.enums.checklist_complementary_items.tie_rod_end_right',
          label: 'Terminal de Direção Direito',
        },
        {
          position: ChecklistPortoComplementaryCategory.Two,
          value: 'domain.enums.checklist_complementary_items.tie_rod_end_left',
          label: 'Terminal de Direção Esquerdo',
        },
        {
          position: ChecklistPortoComplementaryCategory.Two,
          value:
            'domain.enums.checklist_complementary_items.shock_absorber_front_kit',
          label: 'Kit do Amortecedor Dianteiro',
        },
        {
          position: ChecklistPortoComplementaryCategory.Two,
          value:
            'domain.enums.checklist_complementary_items.shock_absorber_front_right',
          label: 'Amortecedor Dianteiro Direito',
        },
        {
          position: ChecklistPortoComplementaryCategory.Two,
          value:
            'domain.enums.checklist_complementary_items.shock_absorber_front_left',
          label: 'Amortecedor Dianteiro Esquerdo',
        },
        {
          position: ChecklistPortoComplementaryCategory.Two,
          value:
            'domain.enums.checklist_complementary_items.spring_front_right',
          label: 'Mola Dianteira Direito',
        },
        {
          position: ChecklistPortoComplementaryCategory.Two,
          value: 'domain.enums.checklist_complementary_items.spring_front_left',
          label: 'Mola Dianteira Esquerdo',
        },
        {
          position: ChecklistPortoComplementaryCategory.Two,
          value:
            'domain.enums.checklist_complementary_items.wheel_hub_front_right',
          label: 'Cubo da roda dianteiro Direito',
        },
        {
          position: ChecklistPortoComplementaryCategory.Two,
          value:
            'domain.enums.checklist_complementary_items.wheel_hub_front_left',
          label: 'Cubo da roda dianteiro Esquerdo',
        },
        {
          position: ChecklistPortoComplementaryCategory.Two,
          value:
            'domain.enums.checklist_complementary_items.wheel_bearing_front_right',
          label: 'Rolamento da Roda Dianteira Direito',
        },
        {
          position: ChecklistPortoComplementaryCategory.Two,
          value:
            'domain.enums.checklist_complementary_items.wheel_bearing_front_left',
          label: 'Rolamento da Roda Dianteira Esquerdo',
        },
        {
          position: ChecklistPortoComplementaryCategory.Two,
          value:
            'domain.enums.checklist_complementary_items.suspension_pivot_right',
          label: 'Pivô de Suspensão Direito',
        },
        {
          position: ChecklistPortoComplementaryCategory.Two,
          value:
            'domain.enums.checklist_complementary_items.suspension_pivot_left',
          label: 'Pivô de Suspensão Esquerdo',
        },
        {
          position: ChecklistPortoComplementaryCategory.Two,
          value:
            'domain.enums.checklist_complementary_items.tray_bushing_right',
          label: 'Bucha da Bandeja Direito',
        },
        {
          position: ChecklistPortoComplementaryCategory.Two,
          value: 'domain.enums.checklist_complementary_items.tray_bushing_left',
          label: 'Bucha da Bandeja Esquerdo',
        },
        {
          position: ChecklistPortoComplementaryCategory.Two,
          value:
            'domain.enums.checklist_complementary_items.front_tray_bushing_right',
          label: 'Bandeja Dianteira Direito',
        },
        {
          position: ChecklistPortoComplementaryCategory.Two,
          value:
            'domain.enums.checklist_complementary_items.front_tray_bushing_left',
          label: 'Bandeja Dianteira Esquerdo',
        },
        {
          position: ChecklistPortoComplementaryCategory.Two,
          value: 'domain.enums.checklist_complementary_items.anti_roll_bar',
          label: 'Barra Estabilizadora',
        },
        {
          position: ChecklistPortoComplementaryCategory.Two,
          value: 'domain.enums.checklist_complementary_items.suspension_link',
          label: 'Bieleta Suspensão',
        },
        {
          position: ChecklistPortoComplementaryCategory.Two,
          value: 'domain.enums.checklist_complementary_items.swing_arm_right',
          label: 'Braço Ocilante Direito',
        },
        {
          position: ChecklistPortoComplementaryCategory.Two,
          value: 'domain.enums.checklist_complementary_items.swingarm_left',
          label: 'Braço Ocilante Esquerdo',
        },
        {
          position: ChecklistPortoComplementaryCategory.Two,
          value:
            'domain.enums.checklist_complementary_items.suspension_frame_bushing',
          label: 'Bucha do Quadro de Suspensão',
        },
        {
          position: ChecklistPortoComplementaryCategory.Two,
          value: 'domain.enums.checklist_complementary_items.anti_roll_bar_kit',
          label: 'Kit Barra Estabilizadora',
        },
        {
          position: ChecklistPortoComplementaryCategory.Two,
          value: 'domain.enums.checklist_complementary_items.suspension_frame',
          label: 'Quadro da Suspensão',
        },
        {
          position: ChecklistPortoComplementaryCategory.Two,
          value:
            'domain.enums.checklist_complementary_items.suspension_tensioner_right',
          label: 'Tensor de Suspensão Direito',
        },
        {
          position: ChecklistPortoComplementaryCategory.Two,
          value:
            'domain.enums.checklist_complementary_items.suspension_tensioner_left',
          label: 'Tensor de Suspensão Esquerdo',
        },
        {
          position: ChecklistPortoComplementaryCategory.Two,
          value:
            'domain.enums.checklist_complementary_items.swingarm_bushing_right',
          label: 'Bucha Braço Ocilante Direito',
        },
        {
          position: ChecklistPortoComplementaryCategory.Two,
          value:
            'domain.enums.checklist_complementary_items.swingarm_bushing_left',
          label: 'Bucha Braço Ocilante Esquerdo',
        },
        {
          position: ChecklistPortoComplementaryCategory.Two,
          value:
            'domain.enums.checklist_complementary_items.steering_box_cover_right',
          label: 'Coifa Caixa de Direção Direito',
        },
        {
          position: ChecklistPortoComplementaryCategory.Two,
          value:
            'domain.enums.checklist_complementary_items.left_steering_box_cover_left',
          label: 'Coifa Caixa de Direção Esquerdo',
        },
        {
          position: ChecklistPortoComplementaryCategory.Two,
          value: 'domain.enums.checklist_complementary_items.steering_fluid',
          label: 'Fluido da Direção',
        },
        {
          position: ChecklistPortoComplementaryCategory.Two,
          value: 'domain.enums.checklist_complementary_items.gearbox_mount',
          label: 'Coxim do Câmbio',
        },
        {
          position: ChecklistPortoComplementaryCategory.Two,
          value: 'domain.enums.checklist_complementary_items.engine_mount',
          label: 'Coxim do Motor',
        },
        {
          position: ChecklistPortoComplementaryCategory.Two,
          value: 'domain.enums.checklist_complementary_items.hydraulic_hoses',
          label: 'Mangueiras Hidráulicas',
        },
        {
          position: ChecklistPortoComplementaryCategory.Two,
          value:
            'domain.enums.checklist_complementary_items.front_steering_alignment',
          label: 'Alinhamento Direção Dianteira',
        },
        {
          position: ChecklistPortoComplementaryCategory.Two,
          value:
            'domain.enums.checklist_complementary_items.camer_caster_right',
          label: 'Cambagem/Cáster Direito',
        },
        {
          position: ChecklistPortoComplementaryCategory.Two,
          value: 'domain.enums.checklist_complementary_items.camer_caster_left',
          label: 'Cambagem/Cáster Esquerdo',
        },
      ],
    },
    {
      key: ChecklistPortoComplementaryCategory.Three,
      label: '3 - TRANSMISSÃO',
      items: [
        {
          position: ChecklistPortoComplementaryCategory.Three,
          value:
            'domain.enums.checklist_complementary_items.cv_joint_wheel_right',
          label: 'Coifa Homoc. Roda Direito',
        },
        {
          position: ChecklistPortoComplementaryCategory.Three,
          value:
            'domain.enums.checklist_complementary_items.cv_joint_wheel_left',
          label: 'Coifa Homoc. Roda Esquerdo',
        },
        {
          position: ChecklistPortoComplementaryCategory.Three,
          value:
            'domain.enums.checklist_complementary_items.cv_joint_boot_right',
          label: 'Coifa Homoc. Câmbio Direito',
        },
        {
          position: ChecklistPortoComplementaryCategory.Three,
          value:
            'domain.enums.checklist_complementary_items.cv_joint_boot_left',
          label: 'Coifa Homoc. Câmbio Esquerdo',
        },
        {
          position: ChecklistPortoComplementaryCategory.Three,
          value:
            'domain.enums.checklist_complementary_items.homokinetic_gearbox_right',
          label: 'Homocinética Câmbio Direito',
        },
        {
          position: ChecklistPortoComplementaryCategory.Three,
          value:
            'domain.enums.checklist_complementary_items.homokinetic_gearbox_left',
          label: 'Homocinética Câmbio Esquerdo',
        },
        {
          position: ChecklistPortoComplementaryCategory.Three,
          value:
            'domain.enums.checklist_complementary_items.homokinetic_wheel_right',
          label: 'Homocinética Roda Direito',
        },
        {
          position: ChecklistPortoComplementaryCategory.Three,
          value:
            'domain.enums.checklist_complementary_items.homokinetic_wheel_left',
          label: 'Homocinética Roda Esquerdo',
        },
        {
          position: ChecklistPortoComplementaryCategory.Three,
          value: 'domain.enums.checklist_complementary_items.hand_trim_right',
          label: 'Trizeta Direito',
        },
        {
          position: ChecklistPortoComplementaryCategory.Three,
          value: 'domain.enums.checklist_complementary_items.hand_trim_left',
          label: 'Trizeta Esquerdo',
        },
        {
          position: ChecklistPortoComplementaryCategory.Three,
          value:
            'domain.enums.checklist_complementary_items.clutch_kit_plate_disc_and_bearing',
          label: 'Kit de Embreagem(Plato, Disco e Rolamento)',
        },
        {
          position: ChecklistPortoComplementaryCategory.Three,
          value: 'domain.enums.checklist_complementary_items.pedal_actuator',
          label: 'Atuador Pedal',
        },
        {
          position: ChecklistPortoComplementaryCategory.Three,
          value: 'domain.enums.checklist_complementary_items.gearbox_actuator',
          label: 'Atuador Câmbio',
        },
        {
          position: ChecklistPortoComplementaryCategory.Three,
          value: 'domain.enums.checklist_complementary_items.clutch_cable',
          label: 'Cabo da Embreagem',
        },
      ],
    },
    {
      key: ChecklistPortoComplementaryCategory.Four,
      label: '4 - SUSPENSÃO TRASEIRA',
      items: [
        {
          position: ChecklistPortoComplementaryCategory.Four,
          value:
            'domain.enums.checklist_complementary_items.rear_wheel_bearing_right',
          label: 'Rolamento da Roda Traseira Direito',
        },
        {
          position: ChecklistPortoComplementaryCategory.Four,
          value:
            'domain.enums.checklist_complementary_items.rear_wheel_bearing_left',
          label: 'Rolamento da Roda Traseira Esquerdo',
        },
        {
          position: ChecklistPortoComplementaryCategory.Four,
          value:
            'domain.enums.checklist_complementary_items.rear_wheel_hub_right',
          label: 'Cubo da Roda Traseira Direito',
        },
        {
          position: ChecklistPortoComplementaryCategory.Four,
          value:
            'domain.enums.checklist_complementary_items.rear_wheel_hub_left',
          label: 'Cubo da Roda Traseira Esquerdo',
        },
        {
          position: ChecklistPortoComplementaryCategory.Four,
          value: 'domain.enums.checklist_complementary_items.rear_axle',
          label: 'Eixo Traseiro',
        },
        {
          position: ChecklistPortoComplementaryCategory.Four,
          value:
            'domain.enums.checklist_complementary_items.rear_shock_absorber_kit',
          label: 'Kit do Amortecedor Traseiro',
        },
        {
          position: ChecklistPortoComplementaryCategory.Four,
          value:
            'domain.enums.checklist_complementary_items.rear_shock_absorber',
          label: 'Amortecedor Traseiro',
        },
        {
          position: ChecklistPortoComplementaryCategory.Four,
          value:
            'domain.enums.checklist_complementary_items.rear_spring_beam_right',
          label: 'Mola/feixe Traseiro Direito',
        },
        {
          position: ChecklistPortoComplementaryCategory.Four,
          value:
            'domain.enums.checklist_complementary_items.rear_spring_beam_left',
          label: 'Mola/feixe Traseiro Esquerdo',
        },
        {
          position: ChecklistPortoComplementaryCategory.Four,
          value: 'domain.enums.checklist_complementary_items.rear_tray_right',
          label: 'Bandeja Traseira Direito',
        },
        {
          position: ChecklistPortoComplementaryCategory.Four,
          value: 'domain.enums.checklist_complementary_items.rear_tray_left',
          label: 'Bandeja Traseira Esquerdo',
        },
        {
          position: ChecklistPortoComplementaryCategory.Four,
          value:
            'domain.enums.checklist_complementary_items.rear_bushing_right',
          label: 'Bucha Traseira Direito',
        },
        {
          position: ChecklistPortoComplementaryCategory.Four,
          value: 'domain.enums.checklist_complementary_items.rear_bushing_left',
          label: 'Bucha Traseira Esquerdo',
        },
        {
          position: ChecklistPortoComplementaryCategory.Four,
          value: 'domain.enums.checklist_complementary_items.rear_alignment',
          label: 'Alinhamento Traseiro',
        },
      ],
    },
    {
      key: ChecklistPortoComplementaryCategory.Five,
      label: '5 - SISTEMA DE FREIOS',
      items: [
        {
          position: ChecklistPortoComplementaryCategory.Five,
          value: 'domain.enums.checklist_complementary_items.brake_switch',
          label: 'Interruptor Freio',
        },
        {
          position: ChecklistPortoComplementaryCategory.Five,
          value:
            'domain.enums.checklist_complementary_items.handbrake_lever_cable',
          label: 'Alavanca Freio Mão/Cabo',
        },
        {
          position: ChecklistPortoComplementaryCategory.Five,
          value: 'domain.enums.checklist_complementary_items.brake_booster',
          label: 'Servofreio',
        },
        {
          position: ChecklistPortoComplementaryCategory.Five,
          value: 'domain.enums.checklist_complementary_items.master_cylinder',
          label: 'Cilindro Mestre',
        },
        {
          position: ChecklistPortoComplementaryCategory.Five,
          value: 'domain.enums.checklist_complementary_items.check_valve',
          label: 'Válvula de Retenção',
        },
        {
          position: ChecklistPortoComplementaryCategory.Five,
          value:
            'domain.enums.checklist_complementary_items.vacuum_hose_tubing',
          label: 'Tabulação / Mangueira Vácuo',
        },
        {
          position: ChecklistPortoComplementaryCategory.Five,
          value: 'domain.enums.checklist_complementary_items.fluid_dot4',
          label: 'Fluido DOT 4',
        },
        {
          position: ChecklistPortoComplementaryCategory.Five,
          value: 'domain.enums.checklist_complementary_items.fluid_dot5',
          label: 'Fluido DOT 5',
        },
        {
          position: ChecklistPortoComplementaryCategory.Five,
          value:
            'domain.enums.checklist_complementary_items.equalizer_cut_off_valve',
          label: 'Válvula Equalizadora / Corte',
        },
        {
          position: ChecklistPortoComplementaryCategory.Five,
          value:
            'domain.enums.checklist_complementary_items.rear_wheel_seal_canvas',
          label: 'Retentor de Roda Traseira Lona',
        },
        {
          position: ChecklistPortoComplementaryCategory.Five,
          value:
            'domain.enums.checklist_complementary_items.rear_wheel_seal_shoe',
          label: 'Retentor de Roda Traseira Sapata',
        },
        {
          position: ChecklistPortoComplementaryCategory.Five,
          value:
            'domain.enums.checklist_complementary_items.rear_wheel_seal_pad_ts',
          label: 'Retentor de Roda Traseira Pastilha TS',
        },
        {
          position: ChecklistPortoComplementaryCategory.Five,
          value: 'domain.enums.checklist_complementary_items.parking_shoe',
          label: 'Sapata de Estacionamento',
        },
        {
          position: ChecklistPortoComplementaryCategory.Five,
          value: 'domain.enums.checklist_complementary_items.drum_disk_ts',
          label: 'Tambor / Disco TS',
        },
        {
          position: ChecklistPortoComplementaryCategory.Five,
          value:
            'domain.enums.checklist_complementary_items.drum_disk_ts_rectification',
          label: 'Tambor / Disco TS - Retifica',
        },
        {
          position: ChecklistPortoComplementaryCategory.Five,
          value:
            'domain.enums.checklist_complementary_items.springs_rear_repair_right',
          label: 'Reparo / Molas Traseira Direito',
        },
        {
          position: ChecklistPortoComplementaryCategory.Five,
          value:
            'domain.enums.checklist_complementary_items.springs_rear_repair_left',
          label: 'Reparo / Molas Traseira Esquerdo',
        },
        {
          position: ChecklistPortoComplementaryCategory.Five,
          value:
            'domain.enums.checklist_complementary_items.wheel_cylinder_right',
          label: 'Cilindro de Roda Direito',
        },
        {
          position: ChecklistPortoComplementaryCategory.Five,
          value:
            'domain.enums.checklist_complementary_items.wheel_cylinder_left',
          label: 'Cilindro de Roda Esquerdo',
        },
        {
          position: ChecklistPortoComplementaryCategory.Five,
          value:
            'domain.enums.checklist_complementary_items.caliper_stand_front_right',
          label: 'Pinça / Cavalete Diante Direito',
        },
        {
          position: ChecklistPortoComplementaryCategory.Five,
          value:
            'domain.enums.checklist_complementary_items.caliper_stand_front_left',
          label: 'Pinça / Cavalete Diante Esquerdo',
        },
        {
          position: ChecklistPortoComplementaryCategory.Five,
          value:
            'domain.enums.checklist_complementary_items.rear_flexible_pipes_right',
          label: 'Flexível / Tubulação Traseira Direito',
        },
        {
          position: ChecklistPortoComplementaryCategory.Five,
          value:
            'domain.enums.checklist_complementary_items.rear_flexible_pipes_left',
          label: 'Flexível / Tubulação Traseira Esquerdo',
        },
        {
          position: ChecklistPortoComplementaryCategory.Five,
          value: 'domain.enums.checklist_complementary_items.pad_sensor_right',
          label: 'Sensor de Pastilha Direito',
        },
        {
          position: ChecklistPortoComplementaryCategory.Five,
          value: 'domain.enums.checklist_complementary_items.pad_sensor_left',
          label: 'Sensor de Pastilha Esquerdo',
        },
        {
          position: ChecklistPortoComplementaryCategory.Five,
          value: 'domain.enums.checklist_complementary_items.pad_front',
          label: 'Pastilha Dianteira',
        },
        {
          position: ChecklistPortoComplementaryCategory.Five,
          value: 'domain.enums.checklist_complementary_items.dt_disc_solid',
          label: 'Disco Dianteiro Sólido',
        },
        {
          position: ChecklistPortoComplementaryCategory.Five,
          value:
            'domain.enums.checklist_complementary_items.dt_disc_ventilated',
          label: 'Disco Dianteiro Ventilado',
        },
        {
          position: ChecklistPortoComplementaryCategory.Five,
          value: 'domain.enums.checklist_complementary_items.dt_disc_ground',
          label: 'Disco Dianteiro Retificado',
        },
        {
          position: ChecklistPortoComplementaryCategory.Five,
          value:
            'domain.enums.checklist_complementary_items.caliper_front_stand_right',
          label: 'Pinça / Cavalete Dianteiro Direito',
        },
        {
          position: ChecklistPortoComplementaryCategory.Five,
          value:
            'domain.enums.checklist_complementary_items.caliper_front_stand_left',
          label: 'Pinça / Cavalete Dianteiro Esquerdo',
        },
        {
          position: ChecklistPortoComplementaryCategory.Five,
          value:
            'domain.enums.checklist_complementary_items.caliper_repair_right',
          label: 'Reparo da Pinça Direito',
        },
        {
          position: ChecklistPortoComplementaryCategory.Five,
          value:
            'domain.enums.checklist_complementary_items.caliper_repair_left',
          label: 'Reparo da Pinça Esquerdo',
        },
        {
          position: ChecklistPortoComplementaryCategory.Five,
          value:
            'domain.enums.checklist_complementary_items.flexible_front_pipe_right',
          label: 'Flexível / Tubo Dianteiro Direito',
        },
        {
          position: ChecklistPortoComplementaryCategory.Five,
          value:
            'domain.enums.checklist_complementary_items.flexible_front_pipe_left',
          label: 'Flexível / Tubo Dianteiro Esquerdo',
        },
      ],
    },
    {
      key: ChecklistPortoComplementaryCategory.Six,
      label: '6 - SISTEMA DE FREIOS ABS',
      items: [
        {
          position: ChecklistPortoComplementaryCategory.Six,
          value: 'domain.enums.checklist_complementary_items.abs_light_panel',
          label: 'Luz ABS Painel',
        },
        {
          position: ChecklistPortoComplementaryCategory.Six,
          value:
            'domain.enums.checklist_complementary_items.abs_control_center',
          label: 'Central de Controle ABS',
        },
        {
          position: ChecklistPortoComplementaryCategory.Six,
          value:
            'domain.enums.checklist_complementary_items.wheel_sensor_front_right',
          label: 'Sensor da Roda Dianteira Direito',
        },
        {
          position: ChecklistPortoComplementaryCategory.Six,
          value:
            'domain.enums.checklist_complementary_items.wheel_sensor_front_left',
          label: 'Sensor da Roda Dianteira Esquerdo',
        },
        {
          position: ChecklistPortoComplementaryCategory.Six,
          value:
            'domain.enums.checklist_complementary_items.wheel_sensor_rear_right',
          label: 'Sensor da Roda Traseira Direito',
        },
        {
          position: ChecklistPortoComplementaryCategory.Six,
          value:
            'domain.enums.checklist_complementary_items.wheel_sensor_rear_left',
          label: 'Sensor da Roda Traseira Esquerdo',
        },
      ],
    },
    {
      key: ChecklistPortoComplementaryCategory.Seven,
      label: '7 - INJEÇÃO ELETRÔNICA/IGNIÇÃO',
      items: [
        {
          position: ChecklistPortoComplementaryCategory.Seven,
          value: 'domain.enums.checklist_complementary_items.fuel_pump',
          label: 'Bomba de Combustível',
        },
        {
          position: ChecklistPortoComplementaryCategory.Seven,
          value:
            'domain.enums.checklist_complementary_items.alternator_ground_cable',
          label: 'Alternador / Cabo Terra',
        },
        {
          position: ChecklistPortoComplementaryCategory.Seven,
          value: 'domain.enums.checklist_complementary_items.battery_ah',
          label: 'Bateria (AH)',
        },
        {
          position: ChecklistPortoComplementaryCategory.Seven,
          value: 'domain.enums.checklist_complementary_items.spark_plugs',
          label: 'Velas de Ignição',
        },
        {
          position: ChecklistPortoComplementaryCategory.Seven,
          value: 'domain.enums.checklist_complementary_items.plug_wire',
          label: 'Cabo de Vela',
        },
        {
          position: ChecklistPortoComplementaryCategory.Seven,
          value: 'domain.enums.checklist_complementary_items.injector_nozzle',
          label: 'Bico Injetor',
        },
        {
          position: ChecklistPortoComplementaryCategory.Seven,
          value: 'domain.enums.checklist_complementary_items.nozzle_cleaning',
          label: 'Limpeza dos Bico',
        },
        {
          position: ChecklistPortoComplementaryCategory.Seven,
          value: 'domain.enums.checklist_complementary_items.ignition_rotor',
          label: 'Rotor de Ignição',
        },
        {
          position: ChecklistPortoComplementaryCategory.Seven,
          value: 'domain.enums.checklist_complementary_items.body',
          label: 'Corpo',
        },
        {
          position: ChecklistPortoComplementaryCategory.Seven,
          value: 'domain.enums.checklist_complementary_items.tbi_cleaning',
          label: 'Limpeza do TBI',
        },
        {
          position: ChecklistPortoComplementaryCategory.Seven,
          value: 'domain.enums.checklist_complementary_items.sensors',
          label: 'Sensores',
        },
      ],
    },
    {
      key: ChecklistPortoComplementaryCategory.Eight,
      label: '8 - LUBRIFICAÇÃO/FILTROS',
      items: [
        {
          position: ChecklistPortoComplementaryCategory.Eight,
          value: 'domain.enums.checklist_complementary_items.engine_oil',
          label: 'Óleo do Motor',
        },
        {
          position: ChecklistPortoComplementaryCategory.Eight,
          value: 'domain.enums.checklist_complementary_items.oil_filter',
          label: 'Filtro de Óleo',
        },
        {
          position: ChecklistPortoComplementaryCategory.Eight,
          value: 'domain.enums.checklist_complementary_items.air_filter',
          label: 'Filtro de Ar',
        },
        {
          position: ChecklistPortoComplementaryCategory.Eight,
          value: 'domain.enums.checklist_complementary_items.cabin_filter',
          label: 'Filtro de cabine',
        },
        {
          position: ChecklistPortoComplementaryCategory.Eight,
          value: 'domain.enums.checklist_complementary_items.fuel_filter',
          label: 'Filtro de combustível',
        },
      ],
    },
    {
      key: ChecklistPortoComplementaryCategory.Nine,
      label: '9 - ARREFECIMENTO',
      items: [
        {
          position: ChecklistPortoComplementaryCategory.Nine,
          value: 'domain.enums.checklist_complementary_items.water_tank_cover',
          label: 'Tampa do Reservatório de Água',
        },
        {
          position: ChecklistPortoComplementaryCategory.Nine,
          value: 'domain.enums.checklist_complementary_items.hoses_pipe_pipe',
          label: 'Mangueiras / Tubo / Cano',
        },
        {
          position: ChecklistPortoComplementaryCategory.Nine,
          value: 'domain.enums.checklist_complementary_items.water_pump',
          label: "Bomba d'Água",
        },
        {
          position: ChecklistPortoComplementaryCategory.Nine,
          value:
            'domain.enums.checklist_complementary_items.thermostatic_valve',
          label: 'Válvula Termostática',
        },
        {
          position: ChecklistPortoComplementaryCategory.Nine,
          value: 'domain.enums.checklist_complementary_items.radiator',
          label: 'Radiador',
        },
        {
          position: ChecklistPortoComplementaryCategory.Nine,
          value: 'domain.enums.checklist_complementary_items.sensors',
          label: 'Sensores',
        },
        {
          position: ChecklistPortoComplementaryCategory.Nine,
          value: 'domain.enums.checklist_complementary_items.electro_fan',
          label: 'Eletro Ventilador',
        },
        {
          position: ChecklistPortoComplementaryCategory.Nine,
          value: 'domain.enums.checklist_complementary_items.block_seal',
          label: 'Selo do Bloco',
        },
      ],
    },
    {
      key: ChecklistPortoComplementaryCategory.Ten,
      label: '10 - MOTOR',
      items: [
        {
          position: ChecklistPortoComplementaryCategory.Ten,
          value: 'domain.enums.checklist_complementary_items.timing_belt',
          label: 'Correia Dentada',
        },
        {
          position: ChecklistPortoComplementaryCategory.Ten,
          value:
            'domain.enums.checklist_complementary_items.air_conditioning_belt',
          label: 'Correia do Ar Condicionado',
        },
        {
          position: ChecklistPortoComplementaryCategory.Ten,
          value: 'domain.enums.checklist_complementary_items.tensioners',
          label: 'Tensionadores',
        },
        {
          position: ChecklistPortoComplementaryCategory.Ten,
          value: 'domain.enums.checklist_complementary_items.poly_belt',
          label: 'Correia Poli-V',
        },
        {
          position: ChecklistPortoComplementaryCategory.Ten,
          value:
            'domain.enums.checklist_complementary_items.poly_v_belt_tensioner',
          label: 'Tensionador da Correia Poli-V',
        },
        {
          position: ChecklistPortoComplementaryCategory.Ten,
          value:
            'domain.enums.checklist_complementary_items.timing_beltensioner',
          label: 'Tensionador da Correia Dentada',
        },
        {
          position: ChecklistPortoComplementaryCategory.Ten,
          value: 'domain.enums.checklist_complementary_items.alternator_belt',
          label: 'Correia do Alternador',
        },
        {
          position: ChecklistPortoComplementaryCategory.Ten,
          value:
            'domain.enums.checklist_complementary_items.hydraulic_pump_belt',
          label: 'Correia da Bomba Hidráulica',
        },
        {
          position: ChecklistPortoComplementaryCategory.Ten,
          value: 'domain.enums.checklist_complementary_items.leaks',
          label: 'Vazamentos',
        },
      ],
    },
  ];
